import { render, staticRenderFns } from "./WorldIcon.vue?vue&type=template&id=9a814e32"
import script from "./WorldIcon.vue?vue&type=script&lang=js"
export * from "./WorldIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports